/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AgentDashboardVisit } from './AgentDashboardVisit';
import {
    AgentDashboardVisitFromJSON,
    AgentDashboardVisitFromJSONTyped,
    AgentDashboardVisitToJSON,
} from './AgentDashboardVisit';

/**
 * Response for the agent dashboard visits endpoint.
 * @export
 * @interface AgentDashboardVisitsResponse
 */
export interface AgentDashboardVisitsResponse {
    /**
     * 
     * @type {Array<AgentDashboardVisit>}
     * @memberof AgentDashboardVisitsResponse
     */
    visits: Array<AgentDashboardVisit>;
    /**
     * 
     * @type {number}
     * @memberof AgentDashboardVisitsResponse
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDashboardVisitsResponse
     */
    agentName: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDashboardVisitsResponse
     */
    agentEmail: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDashboardVisitsResponse
     */
    resourcesGuideUrl: string;
}

/**
 * Check if a given object implements the AgentDashboardVisitsResponse interface.
 */
export function instanceOfAgentDashboardVisitsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "visits" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "agentName" in value;
    isInstance = isInstance && "agentEmail" in value;
    isInstance = isInstance && "resourcesGuideUrl" in value;

    return isInstance;
}

export function AgentDashboardVisitsResponseFromJSON(json: any): AgentDashboardVisitsResponse {
    return AgentDashboardVisitsResponseFromJSONTyped(json, false);
}

export function AgentDashboardVisitsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentDashboardVisitsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'visits': ((json['visits'] as Array<any>).map(AgentDashboardVisitFromJSON)),
        'total': json['total'],
        'agentName': json['agent_name'],
        'agentEmail': json['agent_email'],
        'resourcesGuideUrl': json['resources_guide_url'],
    };
}

export function AgentDashboardVisitsResponseToJSON(value?: AgentDashboardVisitsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'visits': ((value.visits as Array<any>).map(AgentDashboardVisitToJSON)),
        'total': value.total,
        'agent_name': value.agentName,
        'agent_email': value.agentEmail,
        'resources_guide_url': value.resourcesGuideUrl,
    };
}

